import { createContext } from 'react'

/**
 * @typedef {object} WorkQueueUpdateContextValue
 * @property {string | null} slug
 * @property {number | string | null} caseId
 * @property {string | null} activeTabKey
 */

/** When set, quick-updates from embedded patient tabs should include `workq` (same as WorkQRow). */
export const WorkQueueUpdateContext = createContext(
    /** @type {WorkQueueUpdateContextValue | null} */ (null)
)
